export const REPORT_REASONS = {
  campaign: [
    'Fraudulent or scam campaign',
    'Misuse of funds',
    'False information',
    'Impersonation',
    'Inappropriate content',
    'Privacy violation',
    'Spam or duplicate campaign',
    'Other'
  ],
  event: [
    'Fraudulent event',
    'False information',
    'Inappropriate content',
    'Spam or duplicate event',
    'Safety concerns',
    'Privacy violation',
    'Cancelled but still accepting registrations',
    'Other'
  ],
  group: [
    'Harassment or bullying',
    'Hate speech',
    'Inappropriate content',
    'Spam or fake group',
    'Privacy violation',
    'Impersonation',
    'Violence or threats',
    'Other'
  ],
  user: [
    'Harassment or bullying',
    'Hate speech or offensive language',
    'Inappropriate behavior',
    'Spam or fake account',
    'Privacy violation',
    'Impersonation or fake identity',
    'Threats or violent content',
    'Fraudulent activity',
    'Inappropriate profile content',
    'Suspicious activity',
    'Other'
  ],
  user_ROSCA: [
    'Defaulting on contributions',
    'Attempting to skip rotation order',
    'Misuse of pooled funds',
    'Fraudulent ROSCA participation',
    'Failure to pay when due',
    'Attempting to receive funds out of turn',
    'Providing false financial information',
    'Threatening group financial stability',
    'Unauthorized early withdrawal requests',
    'Sabotaging rotation system',
    'Other ROSCA violation'
  ],
  user_COMMUNITY_UPLIFT: [
    'Misuse of community funds',
    'False hardship claims',
    'Not contributing while receiving support',
    'Exploiting community generosity',
    'Discriminatory allocation suggestions',
    'Hoarding community resources',
    'Creating fake emergency situations',
    'Undermining fair distribution',
    'Pressuring others for preferential treatment',
    'Abusing trust-based system',
    'Other community trust violation'
  ],
  user_EDUCATIVE: [
    'Financial advice scams',
    'Misleading investment advice',
    'Pyramid scheme promotion',
    'Unauthorized financial solicitation',
    'Predatory lending offers',
    'Fake financial educator',
    'Sharing dangerous financial strategies',
    'Identity theft attempts',
    'Pressure to invest in risky schemes',
    'Unauthorized financial coaching',
    'Other financial misconduct'
  ]
};